import yup from "../../../../../../../utils/yup-extended";
import {Controller, useForm} from "react-hook-form";
import {ShowRenameModalArgs} from "../../content-list-item/types";
import {yupResolver} from "@hookform/resolvers/yup";
import {Button, Input, message, Space} from "antd";
import {FormField, FormFieldError} from "../../../../../../../design-system/form-field";
import {useProductRenameContent} from "../../../../../../../react-query-hooks/products/rename-content";
import {ProductRenameContentApiPayload} from "../../../../../../../react-query-hooks/products/rename-content/types";

const renameSchema = yup.object().shape({
  fileName: yup.string().trim().required("File name is required"),
});

export function ProductRenameContentModalContent({
  renameModalDetails,
  handleRenameContentModalCancel,
  handleRenameContentModalOk,
}: {
  renameModalDetails: ShowRenameModalArgs;
  handleRenameContentModalOk: () => void;
  handleRenameContentModalCancel: () => void;
}) {
  const renameProductContentMutation = useProductRenameContent();

  const {handleSubmit, formState, control, watch} = useForm<{fileName: string}>({
    resolver: yupResolver(renameSchema),
    mode: "onChange",
    defaultValues: {
      fileName: renameModalDetails.fileName,
    },
  });

  const onSubmit = async (values: {fileName: string}) => {
    const payload: ProductRenameContentApiPayload = {
      contentId: renameModalDetails.contentId,
      fileExtension: renameModalDetails.fileExtension,
      fileName: values.fileName,
      productId: renameModalDetails.productId,
    };

    renameProductContentMutation.mutate(payload, {
      onSuccess: () => {
        message.success("Your media content has been renamed successfully!");
        handleRenameContentModalOk();
      },
    });
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        <div>
          <FormField
            id={"productContentRename"}
            label={"What would you like to name your file?"}
            renderInput={(id) => (
              <Controller
                control={control}
                name="fileName"
                render={({field: {onChange, value, ref}}) => (
                  <Space direction="vertical" size={16} style={{display: "flex"}}>
                    <Input
                      onChange={onChange}
                      value={value}
                      ref={ref}
                      placeholder="Enter text"
                    />
                    <FormFieldError errorMessage={formState.errors.fileName?.message} />
                  </Space>
                )}
              />
            )}
          />
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
            gap: "8px",
          }}
        >
          <div>
            <Button
              disabled={
                Object.keys(formState.errors).length > 0 ||
                Object.values(watch()).length < 1
              }
              htmlType="submit"
              type="primary"
              size="small"
              loading={renameProductContentMutation.isLoading}
            >
              Done
            </Button>
          </div>
          <div>
            <Button
              onClick={handleRenameContentModalCancel}
              size="small"
              type="ghost"
              disabled={renameProductContentMutation.isLoading}
            >
              Cancel
            </Button>
          </div>
        </div>
      </Space>
    </form>
  );
}
